<kor-icon [icon]="icon" size="xl"></kor-icon>
<h2>{{ label }}</h2>
<p>
  <ng-content></ng-content>
</p>
